import {
  Page_View,
  View_Item_List,
  Select_Item,
  View_Item,
  Add_To_Shopify_Cart,
  Remove_From_Cart,
  View_Cart,
  Checkout,
  Social_Share,
  App_Download,
  File_Download,
  Generate_Lead,
  Email_Signup,
  Audio_Start,
  Faq_Action,
  Faq_Load_More,
  Reviews_Cta,
  Navigation,
  Cta_Click,
  Item_Details,
  Buy_Now_Button_Tapped,
  Add_To_Cart,
  Close_Cart,
  Open_Cart,
  Shop_Button_Clicked,
  Decrease_Quantity,
  Increase_Quantity,
  Mailchimp_Signup_Completed,
  Shop_Nav_Toggle_Clicked,
  Shop_Subnav_Link_Clicked,
  Shop_Mobile_Menu_Icon_Clicked,
  Link_Clicked,
  Lead_Gen_Signup_Completed,
  Main_Nav_Link_Click,
  Subnav_Link_Click,
  Accordion_Toggle_Click,
  Load_More,
  Carousel_Toggle_Click,
  Tab_Click,
  Video_Start,
  Video_Progress,
  Video_Complete,
} from "./Amplitude";
import { REHYDRATION_COMPLETE, OPTIMIZE_ACTIVATE } from "./App";

export const PAGEVIEW_EVENTS = [Page_View];

export const VIDEO_EVENTS = [Video_Start, Video_Progress, Video_Complete];

export const ECOMMERCE_EVENTS = [
  View_Item_List,
  Select_Item,
  View_Item,
  Add_To_Shopify_Cart,
  Remove_From_Cart,
  View_Cart,
  Checkout,
];

export const INTERACTION_EVENTS = [
  Social_Share,
  App_Download,
  File_Download,
  Generate_Lead,
  Email_Signup,
  Audio_Start,
  Faq_Action,
  Faq_Load_More,
  Reviews_Cta,
  Navigation,
  Cta_Click,
  Item_Details,
];

export const NON_USER_EVENTS = [
  Buy_Now_Button_Tapped,
  Add_To_Cart,
  Close_Cart,
  Open_Cart,
  Shop_Button_Clicked,
  Decrease_Quantity,
  Increase_Quantity,
  OPTIMIZE_ACTIVATE,
  Mailchimp_Signup_Completed,
  Shop_Nav_Toggle_Clicked,
  Shop_Subnav_Link_Clicked,
  Shop_Mobile_Menu_Icon_Clicked,
  Link_Clicked,
  Lead_Gen_Signup_Completed,
  Main_Nav_Link_Click,
  Subnav_Link_Click,
  Accordion_Toggle_Click,
  Load_More,
  Carousel_Toggle_Click,
  Tab_Click,
];

export const USER_EVENTS = [REHYDRATION_COMPLETE];

const Gtm = {
  ECOMMERCE_EVENTS,
  INTERACTION_EVENTS,
  NON_USER_EVENTS,
  USER_EVENTS,
};

export default Gtm;
